import { Card, Button, Divider, DatePicker, Modal, Calendar, Grid } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useRef, useState } from "react";
import dayjs from "dayjs";
import BookingPage from "./BookingPage";
const priceMap = {
  // July 2026
  "2026-07-01": 21900,
  "2026-07-02": 22000,
  "2026-07-03": 22100,
  "2026-07-04": 22300,
  "2026-07-05": 22200,
  "2026-07-06": 22400,
  "2026-07-07": 22500,
  "2026-07-08": 22600,
  "2026-07-09": 22450,
  "2026-07-10": 22700,
  "2026-07-11": 22900,
  "2026-07-12": 22800,
  "2026-07-13": 23000,
  "2026-07-14": 23100,
  "2026-07-15": 22950,
  "2026-07-16": 23200,
  "2026-07-17": 23300,
  "2026-07-18": 23500,
  "2026-07-19": 23400,
  "2026-07-20": 23600,
  "2026-07-21": 23700,
  "2026-07-22": 23800,
  "2026-07-23": 23650,
  "2026-07-24": 23900,
  "2026-07-25": 24100,
  "2026-07-26": 24000,
  "2026-07-27": 24200,
  "2026-07-28": 24300,
  "2026-07-29": 24400,
  "2026-07-30": 24500,
  "2026-07-31": 24600,

  // August 2026
  "2026-08-01": 24700,
  "2026-08-02": 24600,
  "2026-08-03": 24500,
  "2026-08-04": 24400,
  "2026-08-05": 24300,
  "2026-08-06": 24200,
  "2026-08-07": 24450,
  "2026-08-08": 24750,
  "2026-08-09": 24650,
  "2026-08-10": 24550,
  "2026-08-11": 24800,
  "2026-08-12": 24900,
  "2026-08-13": 25000,
  "2026-08-14": 25200,
  "2026-08-15": 25500,
  "2026-08-16": 25300,
  "2026-08-17": 25100,
  "2026-08-18": 24950,
  "2026-08-19": 24850,
  "2026-08-20": 25050,
  "2026-08-21": 25250,
  "2026-08-22": 25550,
  "2026-08-23": 25400,
  "2026-08-24": 25300,
  "2026-08-25": 25200,
  "2026-08-26": 25100,
  "2026-08-27": 25000,
  "2026-08-28": 25200,
  "2026-08-29": 25400,
  "2026-08-30": 25350,
  "2026-08-31": 25500,
};
const { useBreakpoint } = Grid;

const BookingSummary = ({  booking, productDetailId }) => {
  
  const [open, setOpen] = useState(false);
  const [showBookingPage, setShowBookingPage] = useState(false);

  const screens = useBreakpoint();
  const today = dayjs();

  const [leftMonth, setLeftMonth] = useState(today.startOf("month"));
  const [rightMonth, setRightMonth] = useState(
    today.startOf("month").add(1, "month"),
  );

  const [selectedDate, setSelectedDate] = useState(today);

  const goPrevMonth = () => {
    setLeftMonth((prev) => prev.subtract(1, "month"));
    setRightMonth((prev) => prev.subtract(1, "month"));
  };

  const goNextMonth = () => {
    setLeftMonth((prev) => prev.add(1, "month"));
    setRightMonth((prev) => prev.add(1, "month"));
  };

  if (!booking) return null;

  // 🔥 FIXED: cellRender (NO DOUBLE DATES)

  const cellRender = (current, info) => {
    if (info.type !== "date") return info.originNode;

    const key = current.format("YYYY-MM-DD");
    const price = priceMap[key];

    const isSelected =
      selectedDate &&
      current.isSame(selectedDate, "day") &&
      current.month() === selectedDate.month();
    const isToday = current.isSame(today, "day"); // ✅ only real current date

    return (
      <div
        className={`
    flex flex-col items-center justify-center rounded-md h-full w-12
    ${isSelected ? "bg-[#0b2c8f] text-white" : ""}
    ${!isSelected && isToday ? "border border-[#0b2c8f]" : ""}
  `}
      >
        <div>{current.date()}</div>

        {price && (
          <div
            class="text-[12px] leading-[12px] font-normal mt-[2px]"            
          >
            ₹{price / 1000}K
          </div>
        )}
      </div>
    );
  };

  // Calculate total price
  const totalPrice = booking.travellers.reduce((sum, traveller) => {
    const priceNumber = Number(traveller.price.replace(/,/g, ""));
    return sum + priceNumber;
  }, 0);

  // 🔥 FIXED: close modal ONLY on date click
  const handleSelect = (date) => {
    setSelectedDate(date);
    setOpen(false);

    // 👉 open booking page slider
    setShowBookingPage(true);
  };

  return (
    <>
      {screens.md && (
        <Card className="rounded-xl border border-[#E5E5E5] shadow-[0px_0px_4px_1px_rgba(0,0,0,0.1)]">         

          {/* <Divider className="my-4" /> */}

          <div className="flex justify-between items-start font-medium mb-1 text-black">
            <div>
              <span className="text-base">Basic Price</span>
              <div className="text-xs text-danger cursor-pointer mb-4">
                View Pricing Table
              </div>
            </div>
            <div>
              <span className="text-lg">
                {booking.currency} {totalPrice.toLocaleString("en-IN")}
              </span>
              <div className="text-xs font-medium text-gray-400 italic">
                {booking.tax_included ? "*Includes taxes" : "*Excludes taxes"}
              </div>
            </div>
          </div>

          <Button
            type="danger"
            size="middle"
            onClick={() => setOpen(true)}
            className="w-full px-12 py-6 text-sm rounded-md bg-danger text-white"
          >
            {booking.button_text || "Select Date"}
          </Button>
        </Card>
      )}

      <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t shadow-lg p-4 md:p-3 flex items-center justify-between z-99">
        <div>
          <div className="text-xs text-gray-500">From:</div>
          <div className="font-semibold text-base">
            {booking.currency} {totalPrice.toLocaleString("en-IN")}
          </div>
        </div>

        <Button
          type="primary"
          className="bg-danger px-6 py-5 text-white font-medium"
          onClick={() => setOpen(true)}
        >
          {booking.button_text || "Check Availability"}
        </Button>
      </div>

      {/* 🔥 Calendar Modal */}
      <Modal
        open={open}
        footer={null}
        onCancel={() => setOpen(false)}
        width={screens.md ? "80%" : "95%"}
        centered
      >
        {screens.md ? (
          // Desktop - Two calendars
          <div className="grid grid-cols-2 gap-8">
            {/* Left Calendar */}
            <div className="custom-calendar">
              <Button
                type="text"
                icon={<LeftOutlined />}
                onClick={goPrevMonth}
              />

              <Calendar
                key={leftMonth.format("YYYY-MM")}
                fullscreen={false}
                value={leftMonth}
                cellRender={cellRender}
                onSelect={handleSelect}
                validRange={[
                  leftMonth.startOf("month"),
                  leftMonth.endOf("month"),
                ]}
              />
            </div>

            {/* Right Calendar */}
            <div className="custom-calendar text-right">
               <Button
                type="text"
                icon={<RightOutlined />}
                onClick={goNextMonth}
                className="ml-auto"
              />
              <Calendar
                key={rightMonth.format("YYYY-MM")}
                fullscreen={false}
                value={rightMonth}
                cellRender={cellRender}
                onSelect={handleSelect}
                validRange={[
                  rightMonth.startOf("month"),
                  rightMonth.endOf("month"),
                ]}
              />             
            </div>
          </div>
        ) : (
          // Mobile - One calendar
          <>
            <div className="flex items-center justify-between mb-4">
              <Button
                type="text"
                icon={<LeftOutlined />}
                onClick={() => setLeftMonth(leftMonth.subtract(1, "month"))}
              />

              <div className="font-semibold">
                {leftMonth.format("MMMM YYYY")}
              </div>

              <Button
                type="text"
                icon={<RightOutlined />}
                onClick={() => setLeftMonth(leftMonth.add(1, "month"))}
              />
            </div>

            <Calendar
              key={leftMonth.format("YYYY-MM")}
              fullscreen={false}
              value={leftMonth}
              cellRender={cellRender}
              onSelect={handleSelect}
              validRange={[
                leftMonth.startOf("month"),
                leftMonth.endOf("month"),
              ]}
            />
          </>
        )}
      </Modal>
      {showBookingPage && selectedDate && (
        <BookingPage
          open={showBookingPage}
          initialDate={selectedDate}
          onClose={() => setShowBookingPage(false)}
          priceMap={priceMap}
          productDetailId={productDetailId}
        />
      )}
    </>
  );
};

export default BookingSummary;
